import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  updateClassForm,
} from "../../../../../store/actions/class.actions";
import { getClassById } from "../../../../../services/classes/classes.service";
import ClassSkeleton from "../../../../skeleton/ClassSkeleton";
import { handlerErrorV2 } from "../../../../../utils/errors";
import Module from "../../../../layout/Module";
import FormPreview from "../FormPreview/FormPreview";
import { useNavigate, useParams } from "react-router-dom";
import AlertSaveButton from "../../../../button/AlertSaveButton";
import { setCurrentCurriculum } from "../../../../../store/actions/assessment.actions";

const Preview = ({ curriculumId }) => {
  const navigate = useNavigate();
  const { classId, studentId } = useParams();
  const redirectStudentId = studentId ? `${studentId}/` : "";

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const onLoad = useCallback(async () => {
    if (classId) {
      setLoading(true);
      try {
        const response = await getClassById(curriculumId, classId);
        if (!response?.data && response?.error) {
          setError(response.error.message || "An error ocurred");
        } else {
          const formData = response?.data || {};
          dispatch(updateClassForm(formData));
          dispatch(setCurrentCurriculum(formData.curriculumId));
        }
      } catch (error) {
        const message = handlerErrorV2(error);
        setError(message);
      } finally {
        setLoading(false);
      }
    }
  }, [curriculumId, classId]);
  
  useEffect(() => {
    onLoad();
  }, [onLoad]);

  const onCancel = () => {
    navigate(`/dashboard/${redirectStudentId}classes/all`);
  };

  return (
    <>
      <Module.BodyHeader className="border-b border-b-2 border-primary flex justify-end">
        <div className="flex items-center justify-end gap-2">
          <AlertSaveButton
            submodule="Classes"
            disabled={loading}
            icon={["fal", "times"]}
            title="Cancel"
            color="primary"
            variant="outlined"
            className="shadow-sm"
            onDontSave={onCancel}
          />
        </div>
      </Module.BodyHeader>
      <Module.BodyContainer classNameWrapper={loading ? "" : "overflow-auto"}>
        {error?.message && (
          <Alert
            severity="error"
            className="absolute left-0 right-0 z-12"
            onClose={() => setError(null)}
          >
            {error?.message}
          </Alert>
        )}
        {loading ? (
          <ClassSkeleton />
        ) : (
          <FormPreview className="h-full" />
        )}
      </Module.BodyContainer>
    </>
  );
};

export default Preview;
